import axios from '@axios'
import axiosDefaultConfig from '@core/app-config/axiosDefaultConfig'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchReports(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${axiosDefaultConfig.backendEndPoint}exports`, { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createReport(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${axiosDefaultConfig.backendEndPoint}exports`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
